/* ================================================================
   NewJaisa — Student Experience
   File    : assets/student-config.js
   Purpose : ONE reusable configuration object consumed by
             student-renderer.js. Contains DATA ONLY — no HTML,
             no DOM logic, no rendering.
   Exposes : window.STUDENT_CONFIG
   Scope   : All partner colleges. Each key below matches the
             "college_code" setting on that college's landing page
             (sections/college-laptop-landing.liquid), which is what
             assets/student-cookie.js stores and assets/student-mode.js
             looks up on the product page.

   Colleges covered:
     - ssipmt      SSIPMT Raipur
     - bit_raipur  BIT Raipur
     - sstc        SSTC Bhilai
     - bit_bhilai  BIT Bhilai
     - sapthagiri  Sapthagiri Bengaluru
     - rit         RIT Raipur
     - blr_stpaulscollege  St. Paul's College Bengaluru

   NOTE — before go-live, please review the two TODOs below:
     1. Coupon codes (SSIPMT1000 / BITR1000 / SSTU1000 / BITB1000 /
        SNPSU1000 / RITEE1000 / STPAULS1000) are DISPLAY COPY ONLY. Create matching
        active discount codes in Shopify Admin -> Discounts, otherwise
        the code shown will fail at checkout.
     2. successStories arrays are intentionally EMPTY. Populate with
        real student testimonials (name, course, quote) once supplied
        by the marketing team -- the section stays hidden until then,
        by design, to avoid publishing placeholder/fabricated reviews.
   ================================================================ */

window.STUDENT_CONFIG = {

  /* ============================================================
     SSIPMT RAIPUR
     ============================================================ */
  ssipmt: {

    collegeCode: 'ssipmt',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: 'Shri Shankaracharya Institute of Professional Management & Technology (SSIPMT)',
    collegeShortName: 'SSIPMT Raipur',
    city: 'Raipur',
    state: 'Chhattisgarh',
    affiliation: 'Affiliated to Chhattisgarh Swami Vivekanand Technical University (CSVTU)',

    accentTheme: {
      primary: '#03B4D7',
      secondary: '#0D77B6',
      accent: '#0DD688',
      highlight: '#FFC72C'
    },

    hero: {
      badgeText: 'Exclusive for SSIPMT Raipur Students',
      title: 'Your Campus Laptop Deal',
      subtitle: 'Genuine, quality-checked refurbished laptops delivered straight to SSIPMT Raipur’s campus and hostels — with warranty, EMI options, and India’s most trusted refurbishment brand.',
      backgroundGradient: 'linear-gradient(135deg, #03B4D7 0%, #0D77B6 100%)',
      logoImage: '',
      logoAlt: 'SSIPMT Raipur'
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: 'Delivered directly to your SSIPMT hostel or campus address.' },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'SSIPMT1000',
      discountText: '₹1,000 OFF',
      description: 'Apply at checkout — exclusive to SSIPMT Raipur students.',
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'Raipur Mobile Care',
      cityLabel: 'Raipur, Chhattisgarh',
      address: 'Shankar Nagar, Raipur, Chhattisgarh',
      mapsUrl: 'https://www.google.com/maps?q=21.2514,81.6296',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20SSIPMT%20Raipur%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: 'Yes, we deliver directly to SSIPMT Raipur’s campus on Old Dhamtari Road, Sejbahar, or your hostel address with tracked, insured shipping.',
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: 'Configurations chosen to comfortably run the tools SSIPMT students actually need.',
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real SSIPMT Raipur student testimonials before go-live */
    ],

    faq: [
      { question: 'Do you deliver to SSIPMT Raipur campus or hostel?', answer: 'Yes, we deliver directly to SSIPMT Raipur’s campus on Old Dhamtari Road, Sejbahar, or your hostel address with tracked, insured shipping.' },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: 'Trusted by students across SSIPMT Raipur.',
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  },

  /* ============================================================
     BIT RAIPUR
     ============================================================ */
  bit_raipur: {

    collegeCode: 'bit_raipur',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: 'Bhilai Institute of Technology, Raipur (BIT Raipur)',
    collegeShortName: 'BIT Raipur',
    city: 'Raipur',
    state: 'Chhattisgarh',
    affiliation: 'Affiliated to Chhattisgarh Swami Vivekanand Technical University (CSVTU)',

    accentTheme: {
      primary: '#0D77B6',
      secondary: '#074C74',
      accent: '#6C5CE7',
      highlight: '#FFC72C'
    },

    hero: {
      badgeText: 'Exclusive for BIT Raipur Students',
      title: 'Your Campus Laptop Deal',
      subtitle: 'Genuine, quality-checked refurbished laptops delivered straight to BIT Raipur’s campus and hostels — with warranty, EMI options, and India’s most trusted refurbishment brand.',
      backgroundGradient: 'linear-gradient(135deg, #0D77B6 0%, #6C5CE7 100%)',
      logoImage: '',
      logoAlt: 'BIT Raipur'
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: 'Delivered directly to your BIT Raipur hostel or campus address.' },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'BITR1000',
      discountText: '₹1,000 OFF',
      description: 'Apply at checkout — exclusive to BIT Raipur students.',
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'Raipur Mobile Care',
      cityLabel: 'Raipur, Chhattisgarh',
      address: 'Shankar Nagar, Raipur, Chhattisgarh',
      mapsUrl: 'https://www.google.com/maps?q=21.2514,81.6296',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20BIT%20Raipur%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: 'Yes, we deliver directly to BIT Raipur’s campus in Kendri, New Raipur (Atal Nagar), or your hostel address with tracked, insured shipping.',
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: 'Configurations chosen to comfortably run the tools BIT Raipur students actually need.',
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real BIT Raipur student testimonials before go-live */
    ],

    faq: [
      { question: 'Do you deliver to BIT Raipur campus or hostel?', answer: 'Yes, we deliver directly to BIT Raipur’s campus in Kendri, New Raipur (Atal Nagar), or your hostel address with tracked, insured shipping.' },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: 'Trusted by students across BIT Raipur.',
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  },

  /* ============================================================
     SSTC BHILAI
     ============================================================ */
  sstc: {

    collegeCode: 'sstc',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: 'Shri Shankaracharya Technical Campus (SSTC)',
    collegeShortName: 'SSTC Bhilai',
    city: 'Bhilai',
    state: 'Chhattisgarh',
    affiliation: 'Affiliated to Chhattisgarh Swami Vivekanand Technical University (CSVTU)',

    accentTheme: {
      primary: '#03B4D7',
      secondary: '#0A5C8A',
      accent: '#FF6B6B',
      highlight: '#FFC72C'
    },

    hero: {
      badgeText: 'Exclusive for SSTC Bhilai Students',
      title: 'Your Campus Laptop Deal',
      subtitle: 'Genuine, quality-checked refurbished laptops delivered straight to SSTC Bhilai’s campus and hostels — with warranty, EMI options, and India’s most trusted refurbishment brand.',
      backgroundGradient: 'linear-gradient(135deg, #03B4D7 0%, #FF6B6B 100%)',
      logoImage: '',
      logoAlt: 'SSTC Bhilai'
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: 'Delivered directly to your SSTC hostel or campus address.' },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'SSTU1000',
      discountText: '₹1,000 OFF',
      description: 'Apply at checkout — exclusive to SSTC Bhilai students.',
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'Bhilai Mobile Care',
      cityLabel: 'Bhilai, Chhattisgarh',
      address: 'Block 8, Plot 4, Ekta Market, Dakshin Gangotri, Supela, Bhilai, Chhattisgarh',
      mapsUrl: 'https://www.google.com/maps?q=21.209,81.4285',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20SSTC%20Bhilai%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: 'Yes, we deliver directly to SSTC’s Junwani campus in Bhilai (Durg district), or your hostel address with tracked, insured shipping.',
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: 'Configurations chosen to comfortably run the tools SSTC students actually need.',
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real SSTC Bhilai student testimonials before go-live */
    ],

    faq: [
      { question: 'Do you deliver to SSTC’s campus or hostel?', answer: 'Yes, we deliver directly to SSTC’s Junwani campus in Bhilai (Durg district), or your hostel address with tracked, insured shipping.' },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: 'Trusted by students across SSTC Bhilai.',
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  },

  /* ============================================================
     BIT BHILAI
     ============================================================ */
  bit_bhilai: {

    collegeCode: 'bit_bhilai',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: 'Bhilai Institute of Technology (BIT), Durg-Bhilai',
    collegeShortName: 'BIT Bhilai',
    city: 'Bhilai',
    state: 'Chhattisgarh',
    affiliation: 'Affiliated to Chhattisgarh Swami Vivekanand Technical University (CSVTU)',

    accentTheme: {
      primary: '#0D77B6',
      secondary: '#095C87',
      accent: '#0DD688',
      highlight: '#FFA53D'
    },

    hero: {
      badgeText: 'Exclusive for BIT Bhilai Students',
      title: 'Your Campus Laptop Deal',
      subtitle: 'Genuine, quality-checked refurbished laptops delivered straight to BIT Bhilai’s campus and hostels — with warranty, EMI options, and India’s most trusted refurbishment brand.',
      backgroundGradient: 'linear-gradient(135deg, #0D77B6 0%, #0DD688 100%)',
      logoImage: '',
      logoAlt: 'BIT Bhilai'
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: 'Delivered directly to your BIT Bhilai hostel or campus address.' },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'BITB1000',
      discountText: '₹1,000 OFF',
      description: 'Apply at checkout — exclusive to BIT Bhilai students.',
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'Bhilai Mobile Care',
      cityLabel: 'Bhilai, Chhattisgarh',
      address: 'Block 8, Plot 4, Ekta Market, Dakshin Gangotri, Supela, Bhilai, Chhattisgarh',
      mapsUrl: 'https://www.google.com/maps?q=21.209,81.4285',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20BIT%20Bhilai%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: 'Yes, we deliver directly to BIT’s original Durg-Bhilai campus, or your hostel address with tracked, insured shipping.',
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: 'Configurations chosen to comfortably run the tools BIT Bhilai students actually need.',
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real BIT Bhilai student testimonials before go-live */
    ],

    faq: [
      { question: 'Do you deliver to BIT’s Durg-Bhilai campus or hostel?', answer: 'Yes, we deliver directly to BIT’s original Durg-Bhilai campus, or your hostel address with tracked, insured shipping.' },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: 'Trusted by students across BIT Bhilai.',
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  },

  /* ============================================================
     SAPTHAGIRI BENGALURU
     ============================================================ */
  sapthagiri: {

    collegeCode: 'sapthagiri',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: 'Sapthagiri College of Engineering (SCE)',
    collegeShortName: 'Sapthagiri',
    city: 'Bengaluru',
    state: 'Karnataka',
    affiliation: 'Affiliated to Visvesvaraya Technological University (VTU)',

    accentTheme: {
      primary: '#03B4D7',
      secondary: '#145DA0',
      accent: '#A855F7',
      highlight: '#FFC72C'
    },

    hero: {
      badgeText: 'Exclusive for Sapthagiri Students',
      title: 'Your Campus Laptop Deal',
      subtitle: 'Genuine, quality-checked refurbished laptops delivered straight to Sapthagiri’s campus and hostels in Bengaluru — with warranty, EMI options, and India’s most trusted refurbishment brand.',
      backgroundGradient: 'linear-gradient(135deg, #03B4D7 0%, #A855F7 100%)',
      logoImage: '',
      logoAlt: 'Sapthagiri College of Engineering'
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: 'Delivered directly to your Sapthagiri hostel or campus address.' },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'SNPSU1000',
      discountText: '₹1,000 OFF',
      description: 'Apply at checkout — exclusive to Sapthagiri students.',
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'East Bangalore Mobile Care',
      cityLabel: 'Bengaluru, Karnataka',
      address: 'No.04, First Floor, Sigma Arcade Building, HAL Old Airport Rd, Beside Tulasi Theater, Bangalore, Karnataka',
      mapsUrl: 'https://www.google.com/maps?q=12.9716,77.5946',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20Sapthagiri%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: 'Yes, we deliver directly to Sapthagiri College of Engineering’s campus on Hesaraghatta Main Road, Bengaluru, or your hostel address with tracked, insured shipping.',
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: 'Configurations chosen to comfortably run the tools Sapthagiri students actually need.',
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real Sapthagiri student testimonials before go-live */
    ],

    faq: [
      { question: 'Do you deliver to Sapthagiri College of Engineering in Bengaluru?', answer: 'Yes, we deliver directly to Sapthagiri College of Engineering’s campus on Hesaraghatta Main Road, Bengaluru, or your hostel address with tracked, insured shipping.' },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: 'Trusted by students across Sapthagiri.',
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  },

  /* ============================================================
     ST. PAUL'S COLLEGE BENGALURU
     ============================================================ */
  blr_stpaulscollege: {

    collegeCode: 'blr_stpaulscollege',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: "St. Paul's College, Bengaluru",
    collegeShortName: "St. Paul's",
    city: 'Bengaluru',
    state: 'Karnataka',
    affiliation: 'Bengaluru, Karnataka',

    accentTheme: {
      primary: '#03B4D7',
      secondary: '#145DA0',
      accent: '#A855F7',
      highlight: '#FFC72C'
    },

    hero: {
      badgeText: "Exclusive for St. Paul's Students",
      title: 'Your Campus Laptop Deal',
      subtitle: "Genuine, quality-checked refurbished laptops delivered straight to St. Paul's College in Bengaluru and nearby hostels — with warranty, EMI options, and India’s most trusted refurbishment brand.",
      backgroundGradient: 'linear-gradient(135deg, #03B4D7 0%, #A855F7 100%)',
      logoImage: '',
      logoAlt: "St. Paul's College Bengaluru"
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: "Delivered directly to your St. Paul's hostel or campus address." },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'STPC1000',
      discountText: '₹1,000 OFF',
      description: "Apply at checkout — exclusive to St. Paul's students.",
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'East Bangalore Mobile Care',
      cityLabel: 'Bengaluru, Karnataka',
      address: 'No.04, First Floor, Sigma Arcade Building, HAL Old Airport Rd, Beside Tulasi Theater, Bangalore, Karnataka',
      mapsUrl: 'https://www.google.com/maps?q=12.9716,77.5946',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20St.%20Paul%27s%20College%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: "Yes, we deliver directly to St. Paul's College in Bengaluru, or your hostel address with tracked, insured shipping.",
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: "Configurations chosen to comfortably run the tools St. Paul's students actually need.",
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real St. Paul's College student testimonials before go-live */
    ],

    faq: [
      { question: "Do you deliver to St. Paul's College in Bengaluru?", answer: "Yes, we deliver directly to St. Paul's College in Bengaluru, or your hostel address with tracked, insured shipping." },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: "Trusted by students across St. Paul's.",
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  },

  /* ============================================================
     RIT RAIPUR
     ============================================================ */
  rit: {

    collegeCode: 'rit',
    collectionHandle: 'ssipmt-student-laptops',
    collegeName: 'Raipur Institute of Technology (RIT)',
    collegeShortName: 'RIT Raipur',
    city: 'Raipur',
    state: 'Chhattisgarh',
    affiliation: 'Affiliated to Chhattisgarh Swami Vivekanand Technical University (CSVTU)',

    accentTheme: {
      primary: '#0D77B6',
      secondary: '#0B4870',
      accent: '#14C38E',
      highlight: '#FFD166'
    },

    hero: {
      badgeText: 'Exclusive for RIT Raipur Students',
      title: 'Your Campus Laptop Deal',
      subtitle: 'Genuine, quality-checked refurbished laptops delivered straight to RIT Raipur’s campus and hostels — with warranty, EMI options, and India’s most trusted refurbishment brand.',
      backgroundGradient: 'linear-gradient(135deg, #0D77B6 0%, #14C38E 100%)',
      logoImage: '',
      logoAlt: 'RIT Raipur'
    },

    benefits: {
      headingText: 'Why Students Choose Us',
      totalValueText: 'Over ₹26,200 in Student-Only Benefits',
      items: [
        { iconImage: '', title: 'Verified Warranty', description: '1-year warranty on every laptop, honoured across India.' },
        { iconImage: '', title: 'Student EMI', description: 'No-cost EMI options built for a student budget.' },
        { iconImage: '', title: 'Quality Checked', description: 'Every unit passes a multi-point quality inspection before dispatch.' },
        { iconImage: '', title: 'Campus Delivery', description: 'Delivered directly to your RIT Raipur hostel or campus address.' },
        { iconImage: '', title: '14-Day Returns', description: 'Not satisfied? Return within 14 days, no questions asked.' },
        { iconImage: '', title: 'Lifetime Buyback', description: 'Sell it back to us anytime at a guaranteed price.' }
      ]
    },

    coupon: {
      code: 'RITEE1000',
      discountText: '₹1,000 OFF',
      description: 'Apply at checkout — exclusive to RIT Raipur students.',
      expiryText: ''
    },

    emi: {
      title: 'Easy Student EMI',
      description: 'Split your payment into easy monthly instalments with zero hidden charges.',
      minTenureText: 'Starting at 3 months',
      highlightText: 'No-cost EMI available'
    },

    serviceCenter: {
      title: 'Nearest Service Center',
      name: 'Raipur Mobile Care',
      cityLabel: 'Raipur, Chhattisgarh',
      address: 'Shankar Nagar, Raipur, Chhattisgarh',
      mapsUrl: 'https://www.google.com/maps?q=21.2514,81.6296',
      hours: 'Mon–Sat, 10:00 AM – 7:00 PM',
      phone: '918088403455',
      whatsappNumber: '919535698866'
    },

    support: {
      title: 'Need Help Choosing?',
      description: 'Talk to our student support team on WhatsApp for personalised recommendations.',
      whatsappNumber: '919535698866',
      whatsappLink: 'https://wa.me/919535698866?text=Hi%2C%20I%27m%20a%20RIT%20Raipur%20student%20and%20I%20have%20a%20question%20about%20a%20laptop.',
      responseTimeText: 'Typically replies within 30 minutes',
      callNumber: '918088403455'
    },

    delivery: {
      title: 'Delivered to Your Campus',
      description: 'Yes, we deliver directly to RIT Raipur’s campus, or your hostel address with tracked, insured shipping.',
      estimatedDaysText: '3–5 business days'
    },

    placement: {
      title: 'Ready for Placements & Projects',
      description: 'Configurations chosen to comfortably run the tools RIT Raipur students actually need.',
      technologies: [
        'AutoCAD / SolidWorks',
        'MATLAB',
        'Visual Studio / VS Code',
        'Python & Data Science stacks',
        'Adobe Creative Suite',
        'Android Studio'
      ]
    },

    accessories: [
      { image: '', title: 'Laptop Bag', description: 'Padded, water-resistant carry bag.' },
      { image: '', title: 'Wireless Mouse', description: 'Ergonomic, plug-and-play.' },
      { image: '', title: 'Cooling Pad', description: 'Keeps performance steady during long study sessions.' },
      { image: '', title: 'Screen Guard', description: 'Anti-glare protection for daily campus use.' }
    ],

    successStories: [
      /* TODO: add real RIT Raipur student testimonials before go-live */
    ],

    faq: [
      { question: 'Do you deliver to RIT Raipur campus or hostel?', answer: 'Yes, we deliver directly to RIT Raipur’s campus, or your hostel address with tracked, insured shipping.' },
      { question: 'Is there a warranty on refurbished laptops?', answer: 'Every laptop comes with a 1-year warranty covering hardware issues, honoured at our service centres across India.' },
      { question: 'Can I pay in EMIs as a student?', answer: 'Yes, no-cost EMI options are available at checkout, designed to fit a student budget.' },
      { question: 'What if the laptop doesn’t work for me?', answer: 'You can return it within 14 days of delivery for a full refund, no questions asked.' },
      { question: 'Can I sell the laptop back later?', answer: 'Yes, our Lifetime Buyback Guarantee lets you sell it back to us anytime at a guaranteed price.' }
    ],

    finalCta: {
      title: 'Get Your Campus-Ready Laptop Today',
      subtitle: 'Trusted by students across RIT Raipur.',
      primaryCtaText: 'Shop Now',
      primaryCtaUrl: '/collections/buy-refurbished-laptops-online-in-india',
      secondaryCtaText: 'Chat on WhatsApp',
      secondaryCtaUrl: 'https://wa.me/919535698866'
    }
  }

};
